import * as Products_Domain_Types from "../actions/types";
import * as viewElements from "../../../infrastructure/actions/creators/view-elements";
import * as Infrastructure_Provider_Actions from "../../../infrastructure/actions/creators/provider";
import api from "../../../api";
import { put, takeLatest, all, call } from "redux-saga/effects";

class ProductsAsyncInterface {
  constructor() {
    this.name = "ProductsAsyncInterface";
  }

  *getProductDomainData(action) {
    try {
      yield put(
        Infrastructure_Provider_Actions.activateLoadingStatus(
          "Load_Product_Domain_Data"
        )
      );
      const products = yield call(api.fetch, {
        url: `/api/products`,
        method: "GET",
        // data: { ...action.payload },
      });
      const brands = yield call(api.fetch, {
        url: `/api/brands`,
        method: "GET",
      });

      // TODO: Tags ve Categories BE endpointinden çekilebilir
      let tags = [];
      products.map((p) => {
        return (tags = [...new Set([...tags, ...p.tags])]);
      });

      let categories = [];
      products.map((p) => {
        return (categories = [...new Set([...categories, p.itemType])]);
      });

      if (brands && products) {
        yield all([
          put({
            type: Products_Domain_Types.UPDATE_PRODUCT_DOMAIN_DATA,
            payload: {
              data: {
                products,
                brands,
                tags,
                categories,
              },
            },
          }),
        ]);
      }
      yield put(
        Infrastructure_Provider_Actions.deactivateLoadingStatus(
          "Load_Product_Domain_Data"
        )
      );
    } catch (err) {
      yield all([
        put(
          viewElements.createToast({
            position: "center top",
            type: "danger",
            title: "Products couldn't loaded!",
            message: `${
              (err.response && err.response.data.message) ||
              err.message ||
              action.t("Static_Unexpected_Error_Occured")
            }`,
          })
        ),
        put(
          Infrastructure_Provider_Actions.deactivateLoadingStatus(
            "Load_Product_Domain_Data"
          )
        ),
      ]);
    }
  }
}

const productsConfigSagaInterface = new ProductsAsyncInterface();
export default function* productsConfigDomainAsyncInterface() {
  yield all([
    takeLatest(
      Products_Domain_Types.LOAD_PRODUCT_DOMAIN_DATA,
      productsConfigSagaInterface.getProductDomainData
    ),
  ]);
}
